import { render, staticRenderFns } from "./offerStappen.vue?vue&type=template&id=03bcd942"
import script from "./offerStappen.vue?vue&type=script&lang=js"
export * from "./offerStappen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports